<script>
import MainContainer from '@/components/container/MainContainer.vue';
import LeftPanel from '@/components/container/LeftPanel.vue';
import RightContainer from '@/components/container/RightContainer.vue';

import ButtonReturn from '@/components/left-panel/unique-buttons/ButtonReturn.vue';

import RequestList from '@/components/page-corporate-requests/RequestList.vue';
import RequestDetail from '@/components/page-corporate-requests/RequestDetail.vue';

import { promiseAll, calculatePromise } from '@/api/default.js';
import autoRefreshMixin from '@/mixins/autoRefreshMixin.js';
import constants from '@/constants';

export default {
    mixins: [autoRefreshMixin],
    components: {
        MainContainer,
        LeftPanel,
        RightContainer,
        ButtonReturn,
        RequestList,
        RequestDetail,
    },
    async mounted() {
        this.$store.commit('IS_LOAD', true);

        const promiseList = await calculatePromise([
            { dispatch: 'loadCorporateRequests', commit: null, isArray: false },
            { dispatch: 'loadPendingCount', commit: null, isArray: false },
        ]);
        await promiseAll(promiseList);

        this.$store.commit('IS_LOAD', false);

        this.startAutoRefresh(
            'loadPendingCount',
            constants.AUTO_REFRESH_INTERVALS.PENDING_COUNT
        );
    },
    computed: {
        constants() {
            return constants;
        },
        statusFilter() {
            return this.$store.getters.CORPORATE_REQUESTS_STATUS_FILTER;
        },
        pendingCount() {
            return this.$store.getters.PENDING_REQUESTS_COUNT;
        },
    },
    methods: {
        async changeStatusFilter(newStatus) {
            this.$store.commit('SET_STATUS_FILTER', newStatus);
            await this.$store.dispatch('applyFilters');
        },
    },
};
</script>

<template>
    <RequestDetail />

    <MainContainer>
        <LeftPanel>
            <ButtonReturn />
            <hr class="left-separator" />

            <label class="chapter_header">Filter by Status:</label>
            <button
                @click="
                    changeStatusFilter(constants.CORPORATE_REQUEST_STATUS.ALL)
                "
                :class="{
                    active:
                        statusFilter === constants.CORPORATE_REQUEST_STATUS.ALL,
                }"
                class="left_button_main_container"
            >
                <label class="cursor_pointer">All Requests</label>
            </button>
            <button
                @click="
                    changeStatusFilter(
                        constants.CORPORATE_REQUEST_STATUS.PENDING
                    )
                "
                :class="{
                    active:
                        statusFilter ===
                        constants.CORPORATE_REQUEST_STATUS.PENDING,
                }"
                class="left_button_main_container status_pending"
            >
                <label class="cursor_pointer">
                    Pending
                    <span v-if="pendingCount > 0" class="badge_count">{{
                        pendingCount
                    }}</span>
                </label>
            </button>
            <button
                @click="
                    changeStatusFilter(
                        constants.CORPORATE_REQUEST_STATUS.CONTACTED
                    )
                "
                :class="{
                    active:
                        statusFilter ===
                        constants.CORPORATE_REQUEST_STATUS.CONTACTED,
                }"
                class="left_button_main_container"
            >
                <label class="cursor_pointer">Contacted</label>
            </button>
            <button
                @click="
                    changeStatusFilter(
                        constants.CORPORATE_REQUEST_STATUS.CONVERTED
                    )
                "
                :class="{
                    active:
                        statusFilter ===
                        constants.CORPORATE_REQUEST_STATUS.CONVERTED,
                }"
                class="left_button_main_container"
            >
                <label class="cursor_pointer">Converted</label>
            </button>
            <button
                @click="
                    changeStatusFilter(
                        constants.CORPORATE_REQUEST_STATUS.REJECTED
                    )
                "
                :class="{
                    active:
                        statusFilter ===
                        constants.CORPORATE_REQUEST_STATUS.REJECTED,
                }"
                class="left_button_main_container"
            >
                <label class="cursor_pointer">Rejected</label>
            </button>
        </LeftPanel>

        <RightContainer>
            <RequestList />
        </RightContainer>
    </MainContainer>
</template>

<style scoped>
.left_button_main_container.active {
    background-color: var(--main-color);
    color: white;
}

.badge_count {
    display: inline-block;
    margin-left: 8px;
    padding: 2px 8px;
    background: #ff4444;
    color: white;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 600;
}

.status_pending:not(.active) .badge_count {
    background: #ff9800;
}
</style>
